import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function EmptyItem({
  text,
  Icon,
  variant = "body2",
  color = "textSecondary",
}) {
  return (
    <Box>
      <Box
        width={150}
        height={150}
        margin="auto"
        marginTop={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Icon
          sx={{
            width: "128px",
            height: "128px",
            color: "#cecece",
          }}
        />
      </Box>
      <Typography
        variant={variant}
        color={color}
        noWrap
        sx={{
          display: "flex",
          justifyContent: "center",
          whiteSpace: "pre-line",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
